import React, { Component } from "react";
import {
  FormLayout,
  Icon,
  Button,
  TextField,
} from "@shopify/polaris";
import { DeleteMinor } from "@shopify/polaris-icons";
import "./index.css";

import Language from '../../i18n/Language';
const t = Language

class AddLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      componentID: props.componentID,
      link: props.link,
      title: props.title,
      errorIndex: props.errorIndex,
    };
  }

  componentDidMount() {

  }

  shouldComponentUpdate(nextProps) {
    if(nextProps.errorIndex !== this.props.errorIndex) {
      this.setState({
        errorIndex: nextProps.errorIndex
      })
    }

    return true;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      componentID: nextProps.componentID,
      link: nextProps.link,
      title: nextProps.title,
    });
  }

  //输入框输入
  handleChange = (id,value) => {
    this.setState({
      [id]: Boolean(value) && value[0] !== '/' ? `/${value}` : value,
    },() => {
      this.changeConponent();
    });
  };

  saveThisData = () => {
    this.props.deleteComponent(this.state.componentID);
  };

  //传回给组件
  changeConponent = async () => {
    this.props.changeComponent({
      id: this.props.componentID,
      link: this.state.link,
      title: this.state.title,
    });
  };

  render() {
    const deleteIcon =
      <div style={{ paddingTop: "1.5rem" }} >
        <Button onClick={this.saveThisData}>
          <Icon source={DeleteMinor} color="inkLighter" />
        </Button>
      </div>;
      
    return (
      <FormLayout.Group condensed>
        <TextField
            label={t("URL")}
            onChange={this.handleChange.bind(this,'link')} 
            value={this.state.link}
            placeholder="/pages/test.html"
            error={this.state.errorIndex?.[`${this.state.componentID}`]?.['urlError']}
        />
        <TextField
            label={t("Title")}
            onChange={this.handleChange.bind(this,'title')} 
            value={this.state.title}
            placeholder={t("your page title")}
            error={this.state.errorIndex?.[`${this.state.componentID}`]?.['titleError']}
        />
        {deleteIcon}
      </FormLayout.Group>
    );
  }
}

export default AddLinks;
